import React, { Component } from 'react';

import Helmet from './Helmet';

const Title = 'Strapi Case Study | Canny';
const Description =
  'Read about how Strapi uses Canny to interact with their community and close more deals.';
const Image = 'https://canny.io/images/14a0259aa60a5452d577c7f13806436b.jpg';

export default class StrapiLandingHelmet extends Component {
  render() {
    return (
      <Helmet
        title={Title}
        meta={[
          { name: 'description', content: Description },
          { property: 'og:image', content: Image },
          { property: 'og:title', content: Title },
          { property: 'og:description', content: Description },
          { property: 'og:url', content: 'https://canny.io/case-studies/strapi' },
          { property: 'og:type', content: 'website' },
          { name: 'twitter:card', content: 'summary_large_image' },
          { name: 'twitter:site', content: '@cannyHQ' },
          { name: 'twitter:title', content: Title },
          { name: 'twitter:description', content: Description },
          { name: 'twitter:image', content: Image },
        ]}
      />
    );
  }
}
